

































import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup(props, context){

    const toTeacherList = () => {
      context.root.$router.push(`/teacher_site/teacher_list`);
    };

    const toTeacherAccessibleStudentPageList = () => {
      context.root.$router.push(`/teacher_site/teacher_accessible_student_page_list`);
    };

    const toUpload = () => {
      
      if(props.tabNo == 1){
        context.root.$router.push(`/teacher_site/teacher_excel_upload`);
      }else if(props.tabNo == 2){
        context.root.$router.push(`/teacher_site/teacher_accessible_student_page_upload`);
      }
    };

    return {
      toTeacherList,
      toTeacherAccessibleStudentPageList,
      toUpload,
    };
  }
})
